import type { IxfWatchlistV1OfacFileKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const OFAC_FILE_BASE_PATH = getResolvedPath('/clearing/compliance/ofac/file');

export const getOfacFilePath: EntityPathBuilder<IxfWatchlistV1OfacFileKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return OFAC_FILE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.ofacFileId) {
        return undefined;
      }

      return getResolvedPath(`${OFAC_FILE_BASE_PATH}/$ofacFileId`, context.keys);
    }
  }
};

export function getOfacFileDetailPath(ofacFileId: string | undefined) {
  if (!ofacFileId) {
    return undefined;
  }

  return getOfacFilePath({ kind: 'detail', keys: { ofacFileId } });
}
